import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { map, catchError } from 'rxjs/operators';
import {ShoppingModel} from '../../models/shopping.model';
import {ShoppingPromotionModel} from '../../models/shopping-promotion.model';
import {NfModel} from '../../models/nf.model';
import {NfCampaignModel} from '../../models/nf-campaign.model';
import {NfResumeModel} from '../../models/nf-resume.model';
import {ScratchModel} from '../../models/scratch.model';
import {CouponResumeModel} from '../../models/coupon-resume.model';
import {CustomerCouponModel} from '../../models/customer-coupon.model';
import {VouchersModel} from '../../models/vouchers.model';
import {QuizModel} from '../../models/quiz.model';

@Injectable()
export class PlaceServiceBase {
  private placeType = 'shopping';

  private URL_UPDATE_SCRATCHE = '/scratches/update';
  private URL_USER_COUPONS = '/user/campaign/[promotionID]/resume';
  private URL_USER_COUPONS_LOTTERY = '/user/coupons/campaign/[promotionID]';
  private URL_CAMPAIGN = '/campaign/[id]';
  private URL_CAMPAIGN_PUBLIC = '/public/campaign/[id]';
  private URL_NFCE = '/nf/nfce/manual';
  private URL_NFCE_CONFIRM = '/nf/nfce/confirm/[nfceID]';
  private URL_LIST_NF = '/user/campaign/[promotionID]/resume';
  private URL_RESUME_NF = '/user/campaign/[promotionID]/resume';
  private URL_REDEEM_COUPONS = '/campaign/[promotionID]/redeem';
  private URL_REDEEM_RESUME = '/user/campaign/[promotionID]/resume-redemption';
  private URL_QUIZ_CAMPAIGN = '/user/quiz/campaign';
  private URL_QUIZ_REGISTER = '/user/quiz/register';
  private URL_LIST: string;
  private URL_LIST_PRIVATE: string;
  private URL_LIST_DISTRICT: string;
  private URL_LIST_CITY: string;
  private URL_LIST_TOWN: string;
  private URL_LIST_PROMOTIONS: string;
  private URL_LIST_PROMOTIONS_PRIVATE: string;
  private URL_CHAIN: string;
  private URL_PROMOTION: string;
  private URL_COUPONS: string;
  private URL_SCRATCHES: string;
  private URL_VOUCHERS: string;
  private URL_PLACE_ESTABLISHMENTS: string;
  public http: Http;

  constructor(http: Http, placeName: string) {
    this.http = http;
    this.placeType = placeName;
    this.URL_LIST = `/${this.placeType}/public`;
    this.URL_LIST_PRIVATE = `/${this.placeType}/list`;
    this.URL_LIST_DISTRICT = `/${this.placeType}/district`;
    this.URL_LIST_CITY = `/${this.placeType}/city`;
    this.URL_LIST_TOWN = `/${this.placeType}/town`;
    this.URL_LIST_PROMOTIONS = `/${this.placeType}/[id]/promotions`;
    this.URL_LIST_PROMOTIONS_PRIVATE = `/${this.placeType}/user/[id]/promotions`;
    this.URL_CHAIN = `/${this.placeType}/get/[id]`;
    this.URL_PROMOTION = `/${this.placeType}/promotion/[id]`;
    this.URL_COUPONS = `/user/coupons/resume/${this.placeType}/[id]`;
    this.URL_SCRATCHES = `/scratches/${this.placeType}/[shoppingID]`;
    this.URL_VOUCHERS = `/customer/vouchers/${this.placeType}/[shoppingID]/[status]`;
    this.URL_PLACE_ESTABLISHMENTS = `/establishments/${this.placeType}/[shoppingID]`;
  }

  get(): Observable<ShoppingModel[]> {
    return this.http.get(this.URL_LIST)
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(() => of('Error, could not load chains'))
      );
  }

  getPrivate(): Observable<ShoppingModel[]> {
        return this.http.get(this.URL_LIST_PRIVATE)
            .pipe(
                map((res: Response) => {
                    return res.json();
                }),
                catchError(() => of('Error, could not load shoppings'))
            );
    }

  getCoupons(shoppingHash: string): Observable<CouponResumeModel[]> {
    return this.http.get(this.URL_COUPONS.replace('[id]', shoppingHash))
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(() => of('Error, could not load COUPONS'))
      );
  }

  getUserCoupons(pomotionHash: string): Observable<CustomerCouponModel[]> {
    return this.http.get(this.URL_USER_COUPONS.replace('[promotionID]', pomotionHash))
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(() => of('Error, could not load COUPONS'))
      );
  }

  getLotteryUserCoupons(pomotionHash: string): Observable<CustomerCouponModel[]> {
    return this.http.get(this.URL_USER_COUPONS_LOTTERY.replace('[promotionID]', pomotionHash))
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(() => of('Error, could not load COUPONS'))
      );
  }

  getScratches(shoppingId: string): Observable<ScratchModel[]> {
    return this.http.get(this.URL_SCRATCHES.replace('[shoppingID]', shoppingId))
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(() => of('Error, could not load scratches'))
      );
  }


  getVouchers(shoppingId: string, status: string): Observable<VouchersModel[]> {
    let url: string = this.URL_VOUCHERS.replace('[shoppingID]', shoppingId);
    url = url.replace('[status]', status);

    return this.http.get(url)
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(() => of('Error, could not load vouchers'))
      );
  }


  updateScratche(model: ScratchModel): Observable<ScratchModel> {
    return this.http.post(this.URL_UPDATE_SCRATCHE, model)
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(() => of('Error, could not load scratches'))
      );
  }


  getListCity(): Observable<ShoppingModel[]> {
    return this.http.get(this.URL_LIST_CITY)
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(() => of('Error, could not load CITY'))
      );
  }

  getListDistrict(): Observable<ShoppingModel[]> {
    return this.http.get(this.URL_LIST_DISTRICT)
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(() => of('Error, could not load DISTRICT'))
      );
  }

  getListTown(): Observable<ShoppingModel[]> {
    return this.http.get(this.URL_LIST_TOWN)
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(() => of('Error, could not load TOWN'))
      );
  }

  getShoppingEstablishments(shoppingHash: string): Observable<any[]> {
    return this.http.get(this.URL_PLACE_ESTABLISHMENTS.replace('[shoppingID]', shoppingHash))
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(() => of('Error, could not load PROMOTIONS'))
      );
  }

  getPromotions(shoppingHash: string): Observable<ShoppingPromotionModel[]> {
    return this.http.get(this.URL_LIST_PROMOTIONS.replace('[id]', shoppingHash))
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(() => of('Error, could not load PROMOTIONS'))
      );
  }

    getPromotionsPrivate(shoppingHash: string): Observable<ShoppingPromotionModel[]> {
        return this.http.get(this.URL_LIST_PROMOTIONS_PRIVATE.replace('[id]', shoppingHash))
            .pipe(
                map((res: Response) => {
                    return res.json();
                }),
                catchError(() => of('Error, could not load PROMOTIONS'))
            );
    }

  getPromotion(promotionHash: string): Observable<ShoppingPromotionModel> {
    return this.http.get(this.URL_PROMOTION.replace('[id]', promotionHash))
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(() => of('Error, could not load PROMOTIONS'))
      );
  }

    getPromotionUserDetails(promotionHash: string): Observable<any> {
        return this.http.get(this.URL_REDEEM_RESUME.replace('[promotionID]', promotionHash))
            .pipe(
                map((res: Response) => {
                    return res.json();
                }),
                catchError(() => of('Error, could not load PROMOTIONS USER DETAILS'))
            );
    }

  getCampaign(promotionHash: string): Observable<any> {
    return this.http.get(this.URL_CAMPAIGN.replace('[id]', promotionHash))
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(() => of('Error, could not load CAMPAIGN'))
      );
  }

  getCampaignPublic(promotionHash: string): Observable<any> {
    return this.http.get(this.URL_CAMPAIGN_PUBLIC.replace('[id]', promotionHash))
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(() => of('Error, could not load CAMPAIGN'))
      );
  }

  getShopping(hashId: string): Observable<ShoppingModel> {
    return this.http.get(this.URL_CHAIN.replace('[id]', hashId))
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(() => of('Error, could not load PROMOTIONS'))
      );
  }

  registerNfcPromotion(code: string): Observable<any> {
    return this.http.post(this.URL_NFCE,
      {url: code, type: 1} )
      .pipe(
        map((res: Response) => {
          if (res.status === 200) {
            return res.json();
          } else {
            return res.status.toString();
          }
        }),
        catchError((erro) => of(erro))
      );
  }

  confirmNfce(nfce: string): Observable<any> {
    return this.http.put(this.URL_NFCE_CONFIRM.replace('[nfceID]', nfce), null, null )
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(() => of(400))
      );
  }

  listNf(promotion: string ): Observable<NfCampaignModel[]> {
    return this.http.get(this.URL_LIST_NF.replace('[promotionID]', promotion))
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(() => of(400))
      );
  }

  getResumeNf(promotion: string ): Observable<NfResumeModel> {
    return this.http.get(this.URL_RESUME_NF.replace('[promotionID]', promotion))
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError(() => of(400))
      );
  }

  redeemCoupons(promotion: string ): Observable<any> {
    return this.http.post(this.URL_REDEEM_COUPONS.replace('[promotionID]', promotion), {promotion: promotion})
      .pipe(
        map((res: Response) => {
          return res.json();
        }),
        catchError((erro) => of(erro))
      );
  }

  getCampaignQuiz(id: number): Observable<any> {
    return this.http.post(this.URL_QUIZ_CAMPAIGN, {campaign: id})
      .pipe(
        map((response: Response) => {
          if (response.status === 200) {
            return response.json();
          } else {
            return response;
          }
        }),
        catchError((erro) => of(erro))
      );
  }

  registerQuiz(campaign: string, desc: number): Observable<any> {
    return this.http.post(this.URL_QUIZ_REGISTER, {campaign: campaign, desc: desc})
      .pipe(
        map((response: Response) => {
          if (response.status === 200) {
            return response.json();
          } else {
            return response;
          }
        }),
        catchError((erro) => of(erro))
      );
  }

}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/core/places.service.ts